import { GoodbyeAggregateEu } from 'src/pages/aggregate-eu/goodbye';

export const AggregateEu = () => {
  return <GoodbyeAggregateEu />;
};
